
const Q = require('q');
const _ = require('lodash');

const modals = require('./modals-api.js');

import * as templates from '../templates/prompt/*';


module.exports = {
	confirm (options) {
		options = _.defaults({
			title: undefined,
			message: undefined,
		}, options);

		return Q.Promise((resolve) => {
			const modal = modals.create({
				templateMode: 'content',
				template: {
					html: templates['confirm'](),
					data: {
						options,
						commit: () => {
							resolve({ status: 'commit' });
							modals.hide(modal);
						},
					},
				},
			});

			modal.on('deleted', () => resolve({ status: 'cancel' }));

			modals.show(modal);
		});
	},

	alert (options) {
		options = _.defaults({
			title: undefined,
			message: undefined,
		}, options);

		return Q.Promise((resolve) => {
			const modal = modals.create({
				templateMode: 'content',
				template: {
					html: templates['alert'](),
					data: {
						options,
						commit: () => {
							resolve({ status: 'commit' });
							modals.hide(modal);
						},
					},
				},
			});

			modal.on('deleted', () => resolve({ status: 'commit' }));

			modals.show(modal);
		});
	},

	waitOrSkip (options) {
		options = _.defaults({
			title: undefined,
			message: undefined,
			waitFor: undefined, // promise to wait for
		}, options);

		const modal = modals.create({
			templateMode: 'content',
			template: {
				html: templates['wait-or-skip'](),
				data: { options },
			},
		});

		return Q.race([
			Q(options.waitFor)
				.then(value => ({ status: 'waited', value })),
			Q.Promise(resolve => {
				modal.on('deleted', () => resolve({ status: 'skipped' }));
				modals.show(modal);
			}),
		])
			.finally(() => modals.hide(modal));
	},
};

